/* global CustomPikaday, dayjs */
import 'html/include/js/pikaday/pikaday-custom';
import AOAvailabilityPaxSelect from '@atomic/organisms/tour_b/availability/picker/paxSelection';

export default class AOAvailabilityDatepicker {
  static travellerDataLoaded = false;

  static shouldTravelWithFriend = false;

  static scrollToSelector = '#js-ao-tour-availability';

  constructor(common, tourId, tourLength, eventCategory = null) {
    this.common = common;
    this.gaEventCategory = eventCategory;
    this.tourId = tourId;
    this.startDates = [];
    this.endDates = [];
    this.selectedDate = null;
    this.tourLength = tourLength || 1;
    this.departureIds = {};
    this.selectedDepartureId = null;
    this.mainSelector = '.scout-component-date-traveller-select';
    this.inputWrapperSelector = '.js-scout-component-date-traveller-select__input-wrapper';
    this.mainCtaSelector = '.js-scout-component-date-traveller-select__cta';
    this.dateInputSelector = '.js-scout-component-date-traveller-select__input--date';
    this.travellerTypeModalClass = 'scout-component-date-traveller-select__traveller-popup';
    this.travellerTypeModalSelector = '.js-tour-availability__traveller-popup';
    this.travellerInputSelector = '.js-scout-component-date-traveller-select__input--pax';
    this.travellerInputClass = 'scout-component-date-traveller-select__input--pax';
    this.travellerInputWrapperSelector = '.js-scout-component-date-traveller-select__single-input-wrapper--travellers';
    this.discountTooltipSelector = '.js-pika-discount-tooltip';
    this.daySelector = '.pika-day';
    this.departuresWrapperSelector = '.js-ao-tour-availability__departures';
    this.departureCardSelector = '.js-ao-tour-availability-departure-card';
    this.departureCardRoomItem = '.js-ao-tour-availability-departure-card__price-item';
    this.departureCardRoomTravellers = '.js-ao-tour-availability-departure-card__price-item-travellers';
    this.departureCardRoomDetail = '.js-ao-tour-availability-departure-card__price-item--detail';
    this.loadingElementHTML = `
                            <div class="ao-tour-availability__variants-loader">
                                <div class="ao-tour-availability__variants-loader-wrapper">
                                    <span class="ao-tour-availability__variants-loader-point"></span>
                                    <span class="ao-tour-availability__variants-loader-point"></span>
                                    <span class="ao-tour-availability__variants-loader-point"></span>
                                </div>
                            </div>
                          `;

    this.eligibleTravellerCategory = [1];
    this.discounted = {};
    this.isMobile = false;
    this.locale = $('html').attr('lang');
    this.applyLabel = $(this.inputWrapperSelector).data('label-apply');

    this.selectorGroups = {
      priceBlock: {
        picker: null,
        paxSelect: null,
        $travellerSelect: $('#priceBlockPaxInput'),
        travellerSelectorEnabled: false,
        highlightedDates: [],
        currentDateSelection: null,
        gaEventName: 'Price Block',
      },
      mainBlock: {
        picker: null,
        paxSelect: null,
        $travellerSelect: $('#mainBlockPaxInput'),
        travellerSelectorEnabled: false,
        highlightedDates: [],
        currentDateSelection: null,
        gaEventName: 'Availablility Section',
      },
    };
    this.discountHoverInitiated = false;
    this.isHiddenClass = 'is-hidden';
    this.callback = () => {};
  }

  initiate(callback) {
    this.isMobile = $(window).width() <= 767;

    if (!$(this.inputWrapperSelector).length) {
      return;
    }

    if (callback) this.callback = callback;

    this.onCtaClick();

    this.common.byUserInteraction('load-calendar-slots', () => {
      this.common.lib.init('dayjs', () => {
        this.common.lib.init('dayjs_plugin_updateLocale', () => {
          this.common.lib.init('dayjs_plugin_utc', () => {
            dayjs.extend(window.dayjs_plugin_updateLocale);
            dayjs.extend(window.dayjs_plugin_utc);
            this.loadCalendarSlots();
          });
        });
      });
    });
  }

  loadCalendarSlots() {
    this.common.sendRequest(`/api/booking/for-tdp/calendar-slots/${this.tourId}`, {}, (data) => {
      if (!data || !data.length) {
        return;
      }

      const minDate = data[0].starts_at;
      const maxDate = data[Object.keys(data).length - 1].starts_at;

      Object.keys(data).forEach((key) => {
        const day = data[key];
        const startingDate = dayjs(day.starts_at).toDate();
        this.startDates.push(startingDate.toDateString());
        this.departureIds[day.tour_departure_id] = startingDate.toDateString();

        if (parseInt(day.discount, 10) > 0) {
          this.discounted[startingDate.getTime()] = day.discount;
        }
      });

      this.initiateCalendar(minDate, maxDate);
    }, { type: 'GET' });
  }

  initiateCalendar(minDate, maxDate) {
    const datepicker = this;
    const { discounted, isMobile } = datepicker;
    const monthNames = this.common.parameters.i18nCalendar.months;
    const weekDaysNames = this.common.parameters.i18nCalendar.weekdays;
    const weekDaysShortest = weekDaysNames.map((name) => name[0]);

    dayjs.updateLocale(this.locale, { months: monthNames });

    this.common.lib.init('customCalendar', () => {
      const calendarInputFields = document.querySelectorAll(this.dateInputSelector);
      calendarInputFields.forEach((calendarField, index) => {
        const selectorGroupName = this.getSelectorGroupName(index);
        const { gaEventName } = datepicker.selectorGroups[selectorGroupName];
        const field = calendarField;
        const { calendarAlignment } = field.dataset;

        const pikadayOpts = {
          theme: 'am-tour-availability__traveller-select',
          position: calendarAlignment || 'bottom left',
          field,
          numberOfMonths: isMobile ? 1 : 2,
          minDate: dayjs(minDate).toDate(),
          maxDate: dayjs(maxDate).toDate(),
          discounted,
          autoClose: !isMobile,
          reposition: false,
          selectDepartureLabel: $(datepicker.inputWrapperSelector).data('label-select-departure'),
          closeLabel: $(datepicker.inputWrapperSelector).data('label-close'),
          i18n: {
            previousMonth: '',
            nextMonth: '',
            months: monthNames,
            weekdays: weekDaysNames,
            weekdaysShort: weekDaysShortest,
          },
          disableDayFn(date) {
            const enabledDates = datepicker.startDates;
            const formattedDate = dayjs(date).toDate().toDateString();

            if (!enabledDates.includes(formattedDate)) {
              return date;
            }

            return false;
          },
          onSelect() {
            field.value = this.getDayjs().locale(datepicker.locale).format('DD MMMM YYYY');
            datepicker.selectedDate = field.value;

            const usDateString = this.getDayjs().utc().toDate().toDateString();
            datepicker.highlightDates(usDateString, datepicker.tourLength, selectorGroupName);
            this.setHighlights(datepicker.selectorGroups[selectorGroupName].highlightedDates);

            // eslint-disable-next-line max-len
            datepicker.selectedDepartureId = Object.keys(datepicker.departureIds).find((key) => datepicker.departureIds[key] === usDateString);

            datepicker.common.sendGoogleEvent(gaEventName, 'Date Selected', `Calendar - ${field.value}`);

            if (isMobile) {
              const discountValue = datepicker.getDiscountFromDate(field.value);
              this.renderMobilePanel(this.getDayjs().locale(datepicker.locale).format('D MMMM YYYY'), discountValue, datepicker.applyLabel);
            } else if (datepicker.selectorGroups[selectorGroupName].travellerSelectorEnabled) {
              datepicker.getDepartureCard(selectorGroupName);
            } else {
              datepicker.getTravellerData(selectorGroupName);
            }
          },
          onOpen() {
            const activeMonth = datepicker.getActiveMonth();

            if (activeMonth) {
              this.gotoMonth(activeMonth);
            }

            if (isMobile) {
              const $calendar = $(this.el);
              datepicker.toggleWithTransition($calendar, true);
            } else {
              datepicker.discountHover(gaEventName);
            }

            datepicker.common.sendGoogleEvent(gaEventName, 'Open', 'Calendar');
          },
          onMobileApply() {
            if (!datepicker.selectorGroups[selectorGroupName].travellerSelectorEnabled) {
              datepicker.getTravellerData(selectorGroupName, true);

              datepicker.common.sendGoogleEvent(
                gaEventName,
                'Apply CTA - Date Selection',
                datepicker.getSelectedDate(),
              );
            } else {
              $('body').removeClass('scrim layer');
              datepicker.getDepartureCard(selectorGroupName);

              datepicker.common.sendGoogleEvent(
                gaEventName,
                'Apply CTA - Pax selector',
                AOAvailabilityPaxSelect.travellerSelected,
              );
            }
          },
          onNextMonth() {
            datepicker.common.sendGoogleEvent(
              gaEventName,
              'Next Month',
              'Calendar',
            );
          },
          onPreviousMonth() {
            datepicker.common.sendGoogleEvent(
              gaEventName,
              'Previous Month',
              'Calendar',
            );
          },
          onLabelClick() {
            datepicker.common.sendGoogleEvent(
              gaEventName,
              'Calendar Dropdown',
              'Calendar',
            );
          },
        };

        if (!index && !this.isMobile) {
          pikadayOpts.container = document.querySelector(`${this.mainSelector}--vertical`);
        }

        this.selectorGroups[selectorGroupName].picker = new CustomPikaday(pikadayOpts);
        this.selectorGroups[selectorGroupName].picker.gotoDate(dayjs(minDate).toDate());
      });
    });
  }

  // eslint-disable-next-line
  getSelectorGroupName (index) {
    const selectorGroupName = index ? 'mainBlock' : 'priceBlock';
    return selectorGroupName;
  }

  getSelectedDate() {
    return this.selectedDate;
  }

  getTravellerData(selectorGroupName) {
    if (this.selectorGroups[selectorGroupName].paxSelect) {
      return;
    }

    const index = selectorGroupName === 'priceBlock' ? 0 : 1;
    this.common.sendRequest(
      `/api/booking/for-tdp/price-categories/${this.tourId}`,
      {},
      (data) => {
        $(this.inputWrapperSelector).eq(index).find(this.travellerInputWrapperSelector).append(data.html);

        AOAvailabilityDatepicker.travellerDataLoaded = true;
        AOAvailabilityDatepicker.shouldTravelWithFriend = data.should_travel_with_a_friend;

        const $travellerModal = $(this.mainSelector).eq(index).find(this.travellerTypeModalSelector);
        $travellerModal.attr('id', selectorGroupName);
        this.filterEligibleTravellers(data.price_categories, selectorGroupName);
        this.enableTravellerSelector(selectorGroupName);
        this.displayTravellerModal($travellerModal, selectorGroupName);
      },
      { type: 'GET' },
    );
  }

  addSecondPaxSelector(emptySelectorGroupName) {
    const index = emptySelectorGroupName === 'priceBlock' ? 0 : 1;
    const $travellerModal = $(this.mainSelector).find(this.travellerTypeModalSelector).clone();

    $travellerModal.attr('id', emptySelectorGroupName);
    $(this.inputWrapperSelector).eq(index).find(this.travellerInputWrapperSelector).append($travellerModal);
    this.enableTravellerSelector(emptySelectorGroupName);
  }

  enableTravellerSelector(selectorGroupName) {
    this.selectorGroups[selectorGroupName].travellerSelectorEnabled = true;
    const index = selectorGroupName === 'priceBlock' ? 0 : 1;
    const $travellerModal = $(this.mainSelector).eq(index).find(this.travellerTypeModalSelector);
    const paxInput = this.selectorGroups[selectorGroupName].$travellerSelect;

    this.selectorGroups[selectorGroupName].paxSelect = new AOAvailabilityPaxSelect(
      this.common,
      this.gaEventCategory,
      index,
      selectorGroupName,
    );
    this.selectorGroups[selectorGroupName].paxSelect.initiate();

    paxInput.on('click', () => {
      if (this.isMobile) {
        this.toggleWithTransition($travellerModal, true);
      } else if ($travellerModal.hasClass(this.isHiddenClass)) {
        paxInput.focus();
        $travellerModal.removeClass(this.isHiddenClass);
      } else {
        paxInput.blur();
        $travellerModal.addClass(this.isHiddenClass);
      }
    });

    this.selectorGroups[selectorGroupName].$travellerSelect.prop('disabled', false);
    $(this.mainCtaSelector).eq(index).prop('disabled', false);
    this.onPaxApply(selectorGroupName);
    this.onOutsideClick($travellerModal);
  }

  displayTravellerModal($travellerModal, selectorGroupName) {
    if (this.isMobile) {
      $travellerModal.addClass(`${this.travellerTypeModalClass}--mobile`);
      this.onPaxApply(selectorGroupName);
      this.toggleWithTransition($travellerModal, true);
    } else {
      const SEPARATOR_MARGIN = 20;
      const $travellerSelectWrapper = $(this.travellerInputWrapperSelector);
      $travellerModal.removeClass(`${this.travellerTypeModalClass}--mobile is-hidden`);
      $travellerModal.css('left', `${$travellerSelectWrapper.offset().left - $travellerSelectWrapper.parents().offset().left - SEPARATOR_MARGIN}px`);
    }
  }

  onOutsideClick($modal) {
    $(document).on('click', (event) => {
      if ($modal.hasClass(this.isHiddenClass)) {
        return;
      }

      if (!$(event.target).hasClass(this.travellerTypeModalClass)
      && !$(event.target).parents(this.travellerTypeModalSelector).length
      && !$(event.target).hasClass(this.travellerInputClass)
      && !$(event.target).parents(this.travellerInputSelector).length
      ) {
        if (this.isMobile) {
          this.toggleWithTransition($modal, false);
        } else {
          $modal.addClass(this.isHiddenClass);
        }
      }
    });
  }

  highlightDates(selectedDate, tourLength, selectorGroupName) {
    if (this.selectorGroups[selectorGroupName].currentDateSelection !== selectedDate) {
      this.selectorGroups[selectorGroupName].highlightedDates = [];
      const date = dayjs(selectedDate).toDate();
      const lastDate = dayjs(date.getTime() + ((tourLength - 1) * 24 * 60 * 60 * 1000)).toDate();

      while (date < lastDate) {
        const firstHighlight = dayjs(date).toDate();
        firstHighlight.setDate(date.getDate() + 1);

        this.selectorGroups[selectorGroupName].highlightedDates.push(firstHighlight.getTime());

        date.setDate(date.getDate() + 1);
      }
    }

    this.selectorGroups[selectorGroupName].currentDateSelection = selectedDate;

    return this.selectorGroups[selectorGroupName].highlightedDates;
  }

  discountHover(gaEventName) {
    let hoverEventFired = false;

    if (this.discountHoverInitiated) {
      return;
    }

    $('body').on('mouseover', this.daySelector, (event) => {
      const $element = $(event.currentTarget);
      $element.siblings(this.discountTooltipSelector).removeClass('hid');

      // only on discount
      if (!hoverEventFired) {
        this.common.sendGoogleEvent(gaEventName, 'Hover', 'Calendar');
        hoverEventFired = true;
      }
    }).on('mouseout', this.daySelector, (event) => {
      const $element = $(event.currentTarget);
      $element.siblings(this.discountTooltipSelector).addClass('hid');
    });

    this.discountHoverInitiated = true;
  }

  onCtaClick() {
    const $mainCta = $(this.mainCtaSelector);

    $mainCta.on('click', (event) => {
      const { isMainSelectorGroup } = event.target.dataset;
      const selectorGroupName = isMainSelectorGroup ? 'mainBlock' : 'priceBlock';
      const selectedDate = this.getSelectedDate(selectorGroupName);
      const { gaEventName } = this.selectorGroups[selectorGroupName];
      const passengers = AOAvailabilityPaxSelect.getPaxSelectorValue(selectorGroupName);

      event.preventDefault();
      AOAvailabilityDatepicker.scrollToBottomDatePaxSection();

      // If the inputs are empty just scroll down
      if (!selectedDate) {
        return;
      }

      this.getDepartureCard(selectorGroupName);

      this.common.sendGoogleEvent(
        gaEventName,
        'Show Avaliability',
        `Pax selector: ${passengers}; ${selectedDate}`,
      );
    });
  }

  getDepartureCard(selectorGroupName, syncInputs = true) {
    let isLoading = false;
    if (syncInputs) {
      this.syncAllInputs(selectorGroupName);
    }

    const passengers = AOAvailabilityPaxSelect.getValues(selectorGroupName);

    if (!isLoading) {
      isLoading = true;

      $(this.departuresWrapperSelector).html(this.loadingElementHTML);

      this.common.sendRequest('/api/booking/for-tdp/departure-cards/load', {
        departure_id: this.selectedDepartureId,
        tour_id: this.tourId,
        passengers,
      }, (data) => {
        $(this.departuresWrapperSelector).html(data.html);

        if (this.isMobile) {
          const queryDepartures = document.querySelector(this.departuresWrapperSelector);
          queryDepartures.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }

        this.common.sendGoogleEvent(
          this.gaEventCategory,
          'Card Loaded',
          `Recommended: ${this.getRoomTypesForTracking()}`,
          {
            eventValue: parseInt($(this.departureCardSelector).data('id'), 10),
          },
        );

        this.callback();
      });
    }
  }

  filterEligibleTravellers(priceCategories, selectorGroupName) {
    let isTravellerSelected = false;
    const selectedTraveller = {};

    if (!priceCategories.length) {
      // eslint-disable-next-line
      console.warn('Price categories missing');
      return;
    }

    // eslint-disable-next-line
    Object.values(priceCategories).forEach((traveller) => {
      if (isTravellerSelected) {
        return;
      }

      if (this.eligibleTravellerCategory.includes(traveller.price_category_type_id)) {
        selectedTraveller.pax = traveller.selected;
        selectedTraveller.title = traveller.title;
        selectedTraveller.category_id = traveller.id;

        isTravellerSelected = true;
      }
    });

    if (!selectedTraveller) {
      // eslint-disable-next-line
      console.warn('No eligible traveller types!');
    }
    this.selectorGroups[selectorGroupName].$travellerSelect.val(`${selectedTraveller.pax} ${selectedTraveller.title}`);
  }

  getDiscountFromDate(date) {
    const timestamp = dayjs(date).toDate().getTime();

    if (!timestamp || !this.discounted) {
      return false;
    }

    return this.discounted[timestamp] || false;
  }

  toggleWithTransition($element, toggle, transitionTime = 200) {
    if (toggle) {
      setTimeout(() => {
        $('body').addClass('scrim layer');
        $element.removeClass(this.isHiddenClass);
      }, transitionTime);
    } else {
      setTimeout(() => {
        $('body').removeClass('scrim layer');
        $element.addClass(this.isHiddenClass);
      }, transitionTime);
    }
  }

  getRoomTypesForTracking() {
    const $rooms = $(this.departureCardRoomItem);

    const roomTypes = [];

    if (!$rooms.length) {
      return null;
    }

    $rooms.forEach((room) => {
      const $room = $(room);
      const travellerPerRooms = $room.next(this.departureCardRoomTravellers).find(this.departureCardRoomDetail).map((ix, item) => $(item).data('ga-label'));

      roomTypes.push(`${$room.data('room-type')}-${travellerPerRooms.selector.join(', ')}`);
    });

    return roomTypes && roomTypes.join(';');
  }

  onPaxApply(selectorGroupName) {
    if (!this.isMobile && selectorGroupName !== 'priceBlock') {
      return;
    }

    $(`#${selectorGroupName}`).find(AOAvailabilityPaxSelect.getMainButton()).on('click', () => {
      this.getDepartureCard(selectorGroupName);
    });
  }

  syncCalendarInputs(newVal, donorGroupName, targetGroupName) {
    const fields = document.querySelectorAll(this.dateInputSelector);
    const donorPicker = this.selectorGroups[donorGroupName].picker;
    const targetPicker = this.selectorGroups[targetGroupName].picker;
    const selectedDateObject = donorPicker.getDayjs();
    const usDateString = selectedDateObject.utc().toDate().toDateString();

    this.highlightDates(usDateString, this.tourLength, targetGroupName);
    targetPicker.setDayjs(selectedDateObject, true);
    targetPicker.setHighlights(this.selectorGroups[targetGroupName].highlightedDates);

    const discountValue = this.getDiscountFromDate(newVal);
    targetPicker.renderMobilePanel(donorPicker.getDayjs().locale(this.locale).format('D MMMM YYYY'), discountValue, this.applyLabel);

    fields.forEach((field) => {
      const fieldToUpdate = field;
      fieldToUpdate.value = newVal;
    });
  }

  syncAllInputs(selectorGroupName) {
    const otherGroupName = selectorGroupName === 'mainBlock' ? 'priceBlock' : 'mainBlock';

    const calendarValue = this.getSelectedDate(selectorGroupName);
    const paxValue = AOAvailabilityPaxSelect.getValues(selectorGroupName);
    if (!paxValue.length) return;
    this.syncCalendarInputs(calendarValue, selectorGroupName, otherGroupName);

    const paxSelectorToUpdate = this.selectorGroups[otherGroupName].paxSelect;
    if (!paxSelectorToUpdate) {
      this.addSecondPaxSelector(otherGroupName);
      this.selectorGroups[otherGroupName].paxSelect.syncPaxInputs(selectorGroupName);
      return;
    }
    paxSelectorToUpdate.syncPaxInputs(selectorGroupName);
  }

  // eslint-disable-next-line
  static scrollToBottomDatePaxSection() {
    const mainSelectorGroup = document.querySelector(AOAvailabilityDatepicker.scrollToSelector);
    mainSelectorGroup.scrollIntoView({ behavior: 'smooth' });
  }

  getActiveMonth() {
    const selectedMonth = $(this.dateInputSelector).data('month-name');

    if (!selectedMonth) {
      return false;
    }

    return dayjs().month(selectedMonth).subtract(1, 'months').format('M');
  }
}
